import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DurationChangeSignalsService {
  durationChanged = signal<number>(0);

  notifyChange(value: any) {
    this.durationChanged.set(value);
  }
}
